import CrmPetControllerClass from "./CrmPetController";

let CCrmPet = null;

export function CrmPetController() {
  if (CCrmPet) return CCrmPet;

  CCrmPet = new CrmPetControllerClass();
  return CCrmPet;
}
